import { render } from "./sense-of-behno.vue?vue&type=template&id=cf85cf94&scoped=true"
import script from "./sense-of-behno.vue?vue&type=script&lang=js"
export * from "./sense-of-behno.vue?vue&type=script&lang=js"

import "./sense-of-behno.vue?vue&type=style&index=0&id=cf85cf94&scoped=true&lang=css"
import "./sense-of-behno.vue?vue&type=style&index=1&id=cf85cf94&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf85cf94"]])

export default __exports__